import React, { ReactNode } from "react";
import {
  createReducer,
  createStore,
  Provider as PRProvider,
} from "react-principal";
import { persistkeys } from "../constants/enum";

type accessToken = any;
interface InitialState {
  accessToken: accessToken;
}
const initialState: InitialState = {
  accessToken: "",
};

const SET_ACCESSTOKEN = "SET_ACCESSTOKEN";
const REMOVE = "REMOVE";

const reducer = createReducer({
  SET_ACCESSTOKEN: (state, { payload: { accessToken } }) => ({
    ...state,
    accessToken,
  }),
  REMOVE: (state) => ({
    ...state,
    accessToken: "",
  }),
});

const setAccessToken = (accessToken: accessToken) => {
  return {
    type: SET_ACCESSTOKEN,
    payload: { accessToken },
  };
};
const logOut = () => {
  return {
    type: REMOVE,
    payload: { ...initialState },
  };
};
const store = createStore<InitialState>({
  reducer,
  initialState,
  persistKey: persistkeys.accessToken,
  storage: window.localStorage,
  mapStateToPersist: ({ accessToken }) => ({
    accessToken,
  }),
});

const setAccessTokenPersistToState = () => store.setToState();
const getTokenFromPersist = () => store.state.accessToken;

const ProviderToken = ({ children }: { children: ReactNode }) => {
  return <PRProvider {...{ store }}>{children}</PRProvider>;
};

export {
  ProviderToken,
  reducer as reducerToken,
  store as storeToken,
  setAccessToken,
  setAccessTokenPersistToState,
  getTokenFromPersist,
  logOut,
};
